__turbopack_context__.v({
  "accordionSlideOverwrite": "toolCalcLinkCard-module-scss-module__hEEE_q__accordionSlideOverwrite",
  "button": "toolCalcLinkCard-module-scss-module__hEEE_q__button",
  "description": "toolCalcLinkCard-module-scss-module__hEEE_q__description",
  "fadeIn": "toolCalcLinkCard-module-scss-module__hEEE_q__fadeIn",
  "fadeOut": "toolCalcLinkCard-module-scss-module__hEEE_q__fadeOut",
  "featured": "toolCalcLinkCard-module-scss-module__hEEE_q__featured",
  "header": "toolCalcLinkCard-module-scss-module__hEEE_q__header",
  "image": "toolCalcLinkCard-module-scss-module__hEEE_q__image",
  "scaleIn": "toolCalcLinkCard-module-scss-module__hEEE_q__scaleIn",
  "scaleOut": "toolCalcLinkCard-module-scss-module__hEEE_q__scaleOut",
  "toolCalcLinkCard": "toolCalcLinkCard-module-scss-module__hEEE_q__toolCalcLinkCard",
  "zoomIn": "toolCalcLinkCard-module-scss-module__hEEE_q__zoomIn",
  "zoomOut": "toolCalcLinkCard-module-scss-module__hEEE_q__zoomOut",
});
